import axios from 'axios';
import { AxiosRequestConfig } from 'axios';
import { verifySetUpCodePayload,DeviceMetrics, heartBeat, deviceStatus } from '../Types';


//const location =window.location.hostname;
//const domain = location.includes('localhost') ? 'enaep.dev23.npdng.org' : location;

/* const HEADER_MYNAEP = {
  'Content-Type': 'application/json', 
  'x-mynaep-request-id': 'c7731e28-c18e-4b9f-b41f-5da9cd9e1e17', 
  'Authorization': 'Basic c2RzLWFwaS1iYXNpYy11c2VyOmlDQU1CRXJJRElsZQ=='
} */
const HEADER_ENAEP = {
  'Content-Type': 'application/json', 
  Authorization:  "Basic YXBwY29uZnVzZXI6QSQkYzBuZnVaYQ"
}
const RequestService = {

postSetupCode : async (paylod:verifySetUpCodePayload,url:string, cb: (arg: any,arg1?: boolean) => void) =>{

try {
  //console.log(url);
    const axiosConfig:AxiosRequestConfig = {
      method: 'post',
      url:  url,
      headers: HEADER_ENAEP,
      data : paylod
    };
    
    axios(axiosConfig)
    .then(function (axiosResponse:any) {
      //console.log(axiosResponse);
      const response = {
        status:axiosResponse.status,
        ...axiosResponse.data
      }
      cb(response);
    })
    .catch(function (error:any) {
      //console.log(error);
      console.error(`[RequestService][validate setup code error][${JSON.stringify(error)}]`);
      if(error.response){
        const response = {
          status:error?.response?.status,
           ...error?.response?.data
        }
        cb(response);
      }
      else {
        console.error(`[RequestService][validate setup code error][${JSON.stringify(error)}]`);
        const response = {
          status:error?.code,
          error: {message: error.message, stack: error.stack}
        }
        cb(response);
      }
      
    });
}
catch(e){
  console.error(`[RequestService][validate setup code error][${JSON.stringify(e)}]`);
    cb(e, true);
}
},

postDeviceMetrics : async (paylod:DeviceMetrics,url: string, patch: boolean, cb?: (arg: any,arg1?: boolean) => void) =>{

  try {
      const axiosConfig:AxiosRequestConfig = {
        method: patch ? 'patch' : 'post',
        url:  url,
        headers: HEADER_ENAEP,
        data : paylod
      };
      
      axios(axiosConfig)
      .then(function (axiosResponse:any) {
        console.log(`[RequestService][postDeviceMetrics] success  ${axiosResponse.status}`);
       return true;
      })
      .catch(function (error:any) {
        //console.log(error);
        console.error(`[RequestService][postDeviceMetrics] error  ${error}`);
        if(error.response){
          return false;
        }
        else {
          console.error(`[RequestService][postDeviceMetrics] error  ${error}`);
         return false;
        }
        
      });
  }
  catch(e){
    console.error(`[RequestService][postDeviceMetrics] error  ${e}`);
    return false;
  }
  },
postHeartbeat : async (paylod:heartBeat,url:string, cb?: (arg: any,arg1?: boolean) => void) =>{
  const HEADER_HB = {
    'Content-Type': 'text/plain', 
    Authorization:  "Basic YXBwY29uZnVzZXI6QSQkYzBuZnVaYQ"
  }
    try {
      //console.log(url);
        const axiosConfig:AxiosRequestConfig = {
          method: 'post',
          url:  url,
          headers: HEADER_HB,
          data : paylod
        };
        
        axios(axiosConfig)
        .then(function (axiosResponse:any) {
          //console.log(axiosResponse);
          const response = {
            status:axiosResponse.status,
            ...axiosResponse.data
          }
          if(!cb) return
          cb(response);
        })
        .catch(function (error:any) {
          //console.log(error);
          console.error(`[RequestService][heartbeat error][${JSON.stringify(error)}]`);
          if(error.response){
            const response = {
              status:error?.response?.status,
               ...error?.response?.data
            }
            if(!cb) return
            cb(response);
          }
          else {
            console.error(`[RequestService][heartbeat error][${JSON.stringify(error)}]`);
            const response = {
              status:error?.code,
              error: {message: error.message, stack: error.stack}
            }
            if(!cb) return
            cb(response);
          }
          
        });
    }
    catch(e){
      console.error(`[RequestService][heartbeat error][${JSON.stringify(e)}]`);
      if(!cb) return
        cb(e, true);
    }
    },
  
    getDeviceStatus : async (paylod:deviceStatus,url:string, cb?: (arg: any,arg1?: boolean) => void) =>{
      const HEADER_DS = {
        'Content-Type': 'application/json', 
        'x-mynaep-request-id': 'c7731e28-c18e-4b9f-b41f-5da9cd9e1e17', 
        'Authorization': 'Basic c2RzLWFwaS1iYXNpYy11c2VyOmlDQU1CRXJJRElsZQ=='
      }
        try {
          //console.log(url);
            const axiosConfig:AxiosRequestConfig = {
              method: 'post',
              timeout: 15000,
              url:  url,
              headers: HEADER_DS,
              data : paylod
            };
            
            axios(axiosConfig)
            .then(function (axiosResponse:any) {
              //console.log(axiosResponse);
              const response = {
                status:axiosResponse.status,
                ...axiosResponse.data
              }
              if(!cb) return
              cb(response);
            })
            .catch(function (error:any) {
              //console.log(error);
              console.error(`[RequestService][device status error][${JSON.stringify(error)}]`);
              if(error.response){
                const response = {
                  status:error?.response?.status,
                   ...error?.response?.data
                }
                if(!cb) return
                cb(response);
              }
              else {
                console.error(`[RequestService][device status error][${JSON.stringify(error)}]`);
                const response = {
                  status:error?.code,
                  error: {message: error.message, stack: error.stack}
                }
                if(!cb) return
                cb(response);
              }
              
            });
        }
        catch(e){
          console.error(`[RequestService][device status error][${JSON.stringify(e)}]`);
          if(!cb) return
            cb(e, true);
        }
        },  
  };

export default RequestService;